import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { Brain, MessageCircle, BookOpen, Calculator, Heart, Compass } from 'lucide-react';
export function Tomos() {
  const tomos = [{
    icon: <Brain size={20} className="text-accent" data-id="element-234" />,
    title: 'Atención, Funciones Ejecutivas y Autorregulación',
    desc: 'Atención sostenida, memoria de trabajo, planificación y autorregulación.'
  }, {
    icon: <MessageCircle size={20} className="text-accent" data-id="element-235" />,
    title: 'Comprensión, Lenguaje y Comunicación Funcional',
    desc: 'Vocabulario, comprensión, inferencias y comunicación pragmática.'
  }, {
    icon: <BookOpen size={20} className="text-accent" data-id="element-236" />,
    title: 'Lectura, Escritura y Producción Escolar',
    desc: 'Lectura funcional, comprensión lectora y producción escrita guiada.'
  }, {
    icon: <Calculator size={20} className="text-accent" data-id="element-237" />,
    title: 'Matemática Funcional, Lógica y Resolución de Problemas',
    desc: 'Numeración aplicada, lógica, secuencias y resolución de problemas.'
  }, {
    icon: <Heart size={20} className="text-accent" data-id="element-238" />,
    title: 'Regulación Emocional, Conducta y Habilidades Sociales',
    desc: 'Identificación emocional, tolerancia a la frustración y habilidades sociales.'
  }, {
    icon: <Compass size={20} className="text-accent" data-id="element-239" />,
    title: 'Inclusión, Autonomía y Organización Escolar/Profesional',
    desc: 'Rutinas, hábitos, autonomía y participación en contextos inclusivos.'
  }];
  const extras = ['Actividades imprimibles', 'Recursos visuales', 'Plantillas listas para usar', 'Organizado por edades (7–9 · 10–12 · 13–16)'];
  return <section className="pt-6 pb-10" data-id="element-240">
      <div className="max-w-4xl mx-auto px-3" data-id="element-241">
        <FadeIn className="text-center mb-8" data-id="element-242">
          <h2 className="font-display text-2xl md:text-3xl font-bold text-ink mb-2" data-id="element-243">
            🎨Qué incluye el MegaPack Inclusión Lista
          </h2>
          <p className="text-sm text-muted font-medium" data-id="element-244">
            6 tomos principales listos para usar
          </p>
        </FadeIn>

        <FadeIn data-id="element-245">
          <div className="grid md:grid-cols-2 gap-3 mb-8" data-id="element-246">
            {tomos.map((tomo, idx) => <div key={idx} className="flex items-start gap-3 bg-surface border border-accent/15 rounded-xl p-4" data-id="element-247">
                <div className="shrink-0 mt-0.5 bg-accent/10 p-2 rounded-lg" data-id="element-248">
                  {tomo.icon}
                </div>
                <div data-id="element-249">
                  <h3 className="text-ink text-sm font-bold mb-1" data-id="element-250">
                    {tomo.title}
                  </h3>
                  <p className="text-muted text-xs leading-relaxed" data-id="element-251">
                    {tomo.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-252">
          <div className="flex flex-wrap justify-center gap-2 mb-6" data-id="element-253">
            {extras.map((item, idx) => <span key={idx} className="inline-flex items-center gap-1.5 bg-accent/5 border border-accent/20 text-accent text-xs font-semibold px-3 py-1.5 rounded-full" data-id="element-254">
                {item}
              </span>)}
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-255">
          <p className="text-center text-muted/80 text-sm font-medium" data-id="element-256">
            Cada tomo incluye plantillas, recursos visuales y propuestas
            organizadas por edades.
          </p>
        </FadeIn>
      </div>
    </section>;
}